import { Component, OnInit, ViewChild } from '@angular/core';

import * as xlsx from 'xlsx';
import { Utils } from 'src/app/utils/utils';
import { DateUtils } from 'src/app/utils/date-utils';
import { AppComponent } from 'src/app/app.component';
import { NumberUtils } from 'src/app/utils/number-utils';
import { environment } from 'src/environments/environment';
import { CustomForms } from 'src/app/components/forms/custom-forms';

import { JqWidgets } from 'src/app/utils/jqWidgets';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import { jqxWindowComponent } from 'jqwidgets-ng/jqxwindow';

import { CerraduraService } from 'src/app/services/cerraduras/cerradura.service';

import { ElementoModel } from 'src/app/services/elements/models/elem.model';
import { AlarmaCerraduraModel } from 'src/app/services/cerraduras/models/alarmaCerradura';
import { DateIdentificacionModel } from 'src/app/services/cerraduras/models/dateIdentificacion';

import { ModeloSelectComponent } from 'src/app/components/modelo-select/modelo-select.component';
import { PeriodoSelectComponent } from 'src/app/components/periodo-select/periodo-select.component';
import { jqxDateTimeInputComponent } from 'jqwidgets-ng/jqxdatetimeinput';
import { jqxNumberInputComponent } from 'jqwidgets-ng/jqxnumberinput';

@Component({
  selector: 'app-listado-alarma',
  templateUrl: './listado-alarma.component.html',
  styleUrls: ['./listado-alarma.component.css']
})
export class ListadoAlarmaComponent extends CustomForms implements OnInit {

  private componentRef = null;
  public theme = environment.tema;
  @ViewChild('form') form: jqxWindowComponent;
  @ViewChild('grid') myGrid: jqxGridComponent;
  @ViewChild('periodoSelect') periodoSelect: PeriodoSelectComponent;
  @ViewChild('currencyInput') currencyInput: jqxNumberInputComponent;

  // objects
  elementosSelect: ElementoModel[] = [];
  alarma: AlarmaCerraduraModel = new AlarmaCerraduraModel;
  alarmas: AlarmaCerraduraModel[] = [];
  dateFin = new Date();
  dateInicio = new Date();
  dateIdentificacion: DateIdentificacionModel = new DateIdentificacionModel();

  // grid
  dataAdapter: any;
  source: any;
  public langGrid = JqWidgets.getLocalization('es');
  editrow: number = -1;

  columns = [
    { text: 'Id', columntype: 'textbox', filtertype: 'textbox', datafield: 'id', hidden: true },
    { text: 'idElemento', columntype: 'textbox', filtertype: 'textbox', datafield: 'idElemento', hidden: true },

    { text: this.translate('Fecha'), columntype: 'textbox', filtertype: 'textbox', datafield: 'fecha', width: 140, cellsrenderer: this.renderRow,
      aggregates: [{
        'Total': function (aggregatedValue, currentValue: number) {
          return aggregatedValue + 1;
        }
      }],
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates["Total"] !== undefined) {
          renderstring = '<div style="text-align: left; margin-left: 4px;">' + AppComponent.translate('Total') + ': ' +
            NumberUtils.format(aggregates["Total"], 0) + '</div>';
        }
        return renderstring;
      }
    },
    { text: this.translate('Ns_cerradura'), columntype: 'textbox', filtertype: 'textbox', datafield: 'nsCerradura', width: 120 },
    { text: this.translate('Fecha'), columntype: 'textbox', filtertype: 'textbox', datafield: 'fecha', width: 140, cellsrenderer: this.renderRow },
    { text: this.translate('Bateria'), columntype: 'textbox', filtertype: 'textbox', datafield: 'bateria', width: 110, cellsrenderer: this.renderBateria },
    { text: this.translate('Voltaje'), columntype: 'textbox', filtertype: 'textbox', datafield: 'voltaje', width: 80, cellsrenderer: this.numberrendererDecimales },
    { text: this.translate('Temperatura_elevado'), columntype: 'checkbox', filtertype: 'bool', datafield: 'temperaturaElevado', width: 140, },
    { text: this.translate('Puerta_abierta'), columntype: 'checkbox', filtertype: 'bool', datafield: 'puertaAbierta', width: 100 },
    { text: this.translate('Vandalismo'), columntype: 'checkbox', filtertype: 'bool', datafield: 'vandalismo', width: 100 },
    { text: this.translate('Vaciado'), columntype: 'checkbox', filtertype: 'bool', datafield: 'vaciado', width: 80 },
    { text: this.translate('Puerta_violentada'), columntype: 'checkbox', filtertype: 'bool', datafield: 'puertaViolentada', width: 140 },

    { text: this.translate('Voltaje'), columntype: 'textbox', filtertype: 'textbox', datafield: 'voltaje', width: 80, cellsrenderer: this.numberrendererDecimales },
    { text: this.translate('Temperatura'), columntype: 'textbox', filtertype: 'textbox', datafield: 'temperatura', autowidth: true, cellsrenderer: this.numberrendererDecimales },
    
    {text: this.translate('Elemento'), columntype: 'textbox', filtertype: 'textbox', datafield: 'nombreElemento', cellsrenderer: this.renderText, width: 200},
    {text: this.translate('Marca'), columntype: 'textbox', filtertype: 'textbox', datafield: 'marcaElemento', cellsrenderer: this.renderText, width: 200},
    {text: this.translate('Modelo'), columntype: 'textbox', filtertype: 'textbox', datafield: 'modeloElemento', cellsrenderer: this.renderText, width: 200},
    {text: this.translate('Matricula'), columntype: 'textbox', filtertype: 'textbox', datafield: 'matriculaElemento', cellsrenderer: this.renderText, width: 200},
    {text: this.translate('Observaciones'), columntype: 'textbox', filtertype: 'textbox', datafield: 'observacionesElemento', cellsrenderer: this.renderText, width: 200, sortable: false, filterable: false},

    {text: this.translate('Direccion'), columntype: 'textbox', filtertype: 'textbox', datafield: 'direccionElemento', cellsrenderer: this.renderText, width: 200},
    {text: this.translate('Municipio'), columntype: 'textbox', filtertype: 'textbox', datafield: 'municipioElemento', cellsrenderer: this.renderText, width: 200},
    {text: this.translate('Poblacion'), columntype: 'textbox', filtertype: 'textbox', datafield: 'poblacionElemento', cellsrenderer: this.renderText, width: 200},
  ];

  constructor(private cerraduraService: CerraduraService) {
    super();
  }
  ngOnInit(): void {
    this.getAlarmasByCerraduras(this.dateIdentificacion);
  }

  /**Inicializa el componente
  */
  init(componentRef: any) {
    this.componentRef = componentRef;
  }

  async getAlarmasByCerraduras(date: DateIdentificacionModel) {
    this.source = {
      datatype: 'json',
      dataFields: [
        { name: 'id', type: 'number', map: 'id' },
        { name: 'idElemento', type: 'number', map: 'idElemento' },
        
        { name: 'fecha', type: 'date', map: 'fecha' },
        { name: 'bateria', type: 'number', map: 'bateria' },
        { name: 'voltaje', type: 'string', map: 'voltaje' },
        { name: 'temperaturaElevado', type: 'bool', map: 'temperaturaElevado' },
        { name: 'bateriaBaja', type: 'bool', map: 'bateriaBaja'},
        { name: 'puertaAbierta', type: 'bool', map: 'puertaAbierta' },
        { name: 'vandalismo', type: 'bool', map: 'vandalismo' },
        { name: 'vaciado', type: 'bool', map: 'vaciado' },
        { name: 'puertaViolentada', type: 'bool', map: 'puertaViolentada' },
        
        { name: 'voltaje', type: 'number', map: 'voltaje' },
        { name: 'temperatura', type: 'number', map: 'temperatura' },

        { name: 'nombreElemento', type: 'string', map: 'nombreElemento' },
        { name: 'marcaElemento', type: 'string', map: 'marcaElemento' },
        { name: 'modeloElemento', type: 'string', map: 'modeloElemento' },
        { name: 'matriculaElemento', type: 'string', map: 'matriculaElemento' },
        { name: 'observacionesElemento', type: 'string', map: 'observacionesElemento' },
        
        { name: 'direccionElemento', type: 'string', map: 'direccionElemento' },
        { name: 'municipioElemento', type: 'string', map: 'municipioElemento' },
        { name: 'poblacionElemento', type: 'string', map: 'poblacionElemento' },
      ],
      localdata: this.alarmas
    };
    this.dataAdapter = new jqx.dataAdapter(this.source);
  }

  async ngAfterViewInit(): Promise<void> {
    this.addCustomForm(this.form);
    this.form.setTitle(AppComponent.translate('Informe_alarmas'));
    this.currencyInput.value(50);
    Utils.renderSizeGrid(this.myGrid);
    
    const t = setTimeout(() => {
      clearTimeout(t);
      this.onAceptar(null);
    }, 500);
  }

  renderRow(row: number, columnfield: string, value: any,
    defaulthtml: string, columnproperties: any, rowdata: any): string {
    if (value) {
      let date = new Date(value);
      return '<div style="margin-right: 4px; margin-top: 8px;">' + DateUtils.formatDateTimeShort(date, true) + '</div>';
    }
  }

  numberrenderer(
    row: number,
    columnfield: string,
    value: any,
    defaulthtml: string,
    columnproperties: any,
    rowdata: any
  ): string {
    if (value) {
      return (
        '<div style="margin-right: 4px; margin-top: 8px; text-align: right;">' +
        NumberUtils.format(value, 0) +
        '</div>'
      );
    } else if (value === 0) {
      return (
        '<div style="margin-right: 4px; margin-top: 8px; text-align: right;">' +
        NumberUtils.format(value, 0) +
        '</div>'
      );
    }
  }

  numberrendererDecimales(
    row: number,
    columnfield: string,
    value: any,
    defaulthtml: string,
    columnproperties: any,
    rowdata: any
  ): string {
    if (value) {
      if (columnfield == 'temperatura') {
        value = value / 10
      } else if (columnfield == 'voltaje') {
        value = value / 100
      } else {
        value = value
      }

      return (
        '<div style="margin-right: 4px; margin-top: 5px; text-align: right;">' +
        NumberUtils.format(value, 2) +
        '</div>'
      );
    } else if (value === 0) {
      return (
        '<div style="margin-right: 4px; margin-top: 5px; text-align: right;">' +
        NumberUtils.format(value, 2) +
        '</div>'
      );
    }
  }

  renderText(row: number, columnfield: string, value: any, defaulthtml: string, columnproperties: any, rowdata: any): string {
    if (rowdata.idElemento == 0 || rowdata.idElemento == null) {
      return '';
    } else if (rowdata.nombreElemento == null || rowdata.nsCerradura == null) {
      return '';
    } else {
      return '<div style="margin-right: 4px; margin-top: 8px;">' + rowdata.nombreElemento + '</div>';
    }
  }


  //0=No hay alarma, 1=Batería baja, 2=Batería crítica y 3=Cambiar batería. En el caso de valor 0 no hay que poner nada
  renderBateria(row: number, columnfield: string, value: any, defaulthtml: string, columnproperties: any, rowdata: any): string {
    if (value == 1) {
      return '<div style="margin-left: 4px; margin-top: 8px; text-align: left">' + AppComponent.translate('Alarma_bateria_baja') + '</div>';
    }
    else if (value == 2) {
      return '<div style="margin-left: 4px; margin-top: 8px; text-align: left">' + AppComponent.translate('Alarma_bateria_critica') + '</div>';
    }
    else if (value == 3) {
      return '<div style="margin-left: 4px; margin-top: 8px; text-align: left">' + AppComponent.translate('Cambio_bateria') + '</div>';
    }
    else {
      return '';
    }

  }

  selecElement(listElement: any) {
    this.elementosSelect = listElement;
    if (this.elementosSelect.length <= 0 && this.source) {
      this.alarmas = [];
      this.source.localdata = this.alarmas;
      this.myGrid.updatebounddata();
    }
  }

  onAceptar(event: any) {
    this.dateInicio = this.periodoSelect.getFechaIni();
    this.dateFin = this.periodoSelect.getFechaFin();
    this.dateIdentificacion.Desde = this.dateInicio;
    this.dateIdentificacion.Hasta = this.dateFin;
    this.searchAlarmas();
  }

  onCollapse(event) {
    ModeloSelectComponent._this.onCollapse();
  }

  onExpand(event) {
    ModeloSelectComponent._this.onExpand();
  }

  async searchAlarmas() {
    this.alarmas = await this.cerraduraService.getAlarmas(this.dateIdentificacion);
    if (this.elementosSelect.length > 0) {
      this.alarmas = this.alarmas.filter((alarma, index) => {
        return this.elementosSelect.slice(0, index).some((elem) => elem.cerradura.id == alarma.idCerradura || alarma.idElemento == 0);
      });
    }
    // si no hay elementos seleccionados, no se muestra nada
    // if (!this.elementosSelect.length) {
    //   this.alarmas = [];
    // }
    this.source.localdata = this.alarmas;
    this.myGrid.updatebounddata(this.alarmas);
  }

  onExportar(event: any) {
    const json = JSON.parse(JSON.stringify(this.myGrid.getdisplayrows()));
    const ws: xlsx.WorkSheet = xlsx.utils.json_to_sheet(json);
    const wb: xlsx.WorkBook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(wb, ws, 'Hoja1');
    xlsx.writeFile(wb, DateUtils.formatDateAMDhms(new Date()) + '_InformeAlarmas.xlsx');
  }

  onClose() {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }

  // Para traducir los textos
  public translate(text: string): string {
    return AppComponent.translate(text);
  }
}
